// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3bvkP","bold":"Login_bold__1zwS_"};